import {
  Block,
  HeadingMedium,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import DeFiEcosystem from "#/ui/DeFiEcosystem"
import { LearnSection } from "#/ui/LearnSection"
import { MezoApps } from "#/ui/MezoApps"

export default function ExplorePage() {
  const [_, theme] = useStyletron()

  return (
    <Block>
      <Block padding={`0 ${theme.sizing.scale600}`}>
        <HeadingMedium>Unlock Your Bitcoin&apos;s Full Potential</HeadingMedium>
        <ParagraphLarge>
          Deposit, lock, vote. Put your bitcoin to work.
        </ParagraphLarge>
      </Block>
      <DeFiEcosystem
        marginTop={theme.sizing.scale800}
        marginBottom={theme.sizing.scale900}
      />
      <MezoApps />
      <LearnSection />
    </Block>
  )
}
